import { useState, useEffect } from "react";
import { apiFetch } from "../api";
import { trackEvent } from "../analytics/posthog";
import { PageShell, Card } from "../components";
import s from "./VerifyEmailPage.module.css";

export default function VerifyEmailPage({ onGoHome }) {
  const [status, setStatus] = useState("loading"); // "loading" | "success" | "error"
  const [email, setEmail] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");

    if (!token) {
      setErrorMsg("Missing verification token.");
      setStatus("error");
      return;
    }

    let cancelled = false;
    async function verify() {
      try {
        const res = await apiFetch(
          `/api/v1/premium/verify-and-join?token=${encodeURIComponent(token)}`
        );
        const data = await res.json().catch(() => null);
        if (!res.ok) {
          throw new Error(data?.detail || "Verification failed.");
        }
        if (!cancelled) {
          setEmail(data.email || "");
          setStatus("success");
          trackEvent("email_verified");
        }
      } catch (err) {
        if (!cancelled) {
          setErrorMsg(err.message);
          setStatus("error");
        }
      }
    }
    verify();
    return () => { cancelled = true; };
  }, []);

  return (
    <PageShell>
      <Card>
        <div className={s.container}>
          {status === "loading" && (
            <>
              <div className={s.spinner} />
              <p className={s.text}>Verifying your email...</p>
            </>
          )}

          {status === "success" && (
            <>
              <div className={s.successIcon}>
                <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#2a6e3e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                  <polyline points="22 4 12 14.01 9 11.01" />
                </svg>
              </div>
              <h2 className={s.title}>You're verified!</h2>
              <p className={s.text}>
                We've verified{email ? ` ${email}` : " your email"} and added you to the Premium waiting list.
              </p>
              <div className={s.discountBox}>
                <span className={s.discountLabel}>Your exclusive discount</span>
                <span className={s.discountValue}>50% off</span>
                <span className={s.discountDetail}><s>99 SEK</s> → 49 SEK / month</span>
              </div>
              <p className={s.subtext}>
                Nothing more to do — we'll email you when Premium launches!
              </p>
              <button className={s.homeBtn} onClick={onGoHome}>
                Back to Learning
              </button>
            </>
          )}

          {status === "error" && (
            <>
              <div className={s.errorIcon}>
                <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="10" />
                  <line x1="15" y1="9" x2="9" y2="15" />
                  <line x1="9" y1="9" x2="15" y2="15" />
                </svg>
              </div>
              <h2 className={s.title}>Verification failed</h2>
              <p className={s.text}>{errorMsg}</p>
              <button className={s.homeBtn} onClick={onGoHome}>
                Go Home
              </button>
            </>
          )}
        </div>
      </Card>
    </PageShell>
  );
}
